import { uxp } from "../globals";
import { useListenFromRenderer } from "../message";

export function useListenOpenExternalMessage() {
	useListenFromRenderer([
		{
			key: "openExternal",
			onMessage: (message) => {
				const { url } = message.values;
				if (url) {
					uxp.shell.openExternal(url, "");
				}
			},
		},
	]);
}
